import { BOT } from '../constants/RoutingTypes';
import RoutingRuleBase from './RoutingRuleBase';
export default RoutingRuleBase({
  '@type': BOT,
  botId: null
}, 'BotRoutingRules');